import { render, staticRenderFns } from "./Packs.vue?vue&type=template&id=a63df2c0&scoped=true&"
import script from "./Packs.vue?vue&type=script&lang=ts&"
export * from "./Packs.vue?vue&type=script&lang=ts&"
import style0 from "./Packs.vue?vue&type=style&index=0&id=a63df2c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63df2c0",
  null
  
)

export default component.exports